import { deepEqual } from '../objectUtils';

import { NO_UPDATE_ERROR } from './commonErrorConstants';
import { getSelectMessage } from './errorMessageFunctions';

export const checkDiff = (newEntry, initialState) => {
    return deepEqual(newEntry, initialState)
        ? { button: { error: true, message: NO_UPDATE_ERROR } }
        : {};
};

export const getSelected = (value, subject, ia) => {
    if (
        !value ||
        (typeof value !== 'object' && !value.length) ||
        (typeof value === 'object' && !Object.keys(value).length)
    )
        return { error: true, message: getSelectMessage(subject, ia) };
    return false;
};
